import React, { Component, Fragment } from "react";
import { Route } from "react-router-dom";
import "./App.css";

import LinksPage from "./LinksPage";
import LinkPage from "./LinkPage";
import PublicLinksPage from "./PublicLinksPage";

class App extends Component {
  render() {
    return (
      <Fragment>
        <Route path="/" exact component={LinksPage} />
        <Route path="/link/:url" component={LinkPage} />
        <Route path="/links/:username" component={PublicLinksPage} />
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js